import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";

// import required modules
import { Navigation } from "swiper";
import { header } from "../data/data";

const Header = () => {
  return (
    <div className="h-115 overflow-hidden">
      <div>
        <Swiper navigation={true} modules={[Navigation]} className="mySwiper">
          {header.map((item, index) => (
            <SwiperSlide
              style={{
                background: `url(${item.img}) , linear-gradient(90deg, rgba(27,37,45,1) 5%, rgba(37,45,51,1) 100%)`,
                backgroundBlendMode: "overlay",
              }}
            >
              <div
                className="h-128 flex items-center justify-center"
                key={index}
              >
                <div className="">
                  <h3 className="lg:text-7xl md:text-4xl text-3xl header capitalize font-extrabold px-3 lg:px-0 md:px-0 text-white pb-7">
                    {item.title}
                  </h3>
                  <p className="text-base py-1 px-3 lg:px-0 md:px-0 text-white w-3/4 mx-auto">
                    {item.details}
                  </p>
                  <div className="mt-10">
                    <a href="#_" class="btn">
                      About us
                    </a>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default Header;
